import type { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from '@reduxjs/toolkit';

import type {
  ChallengeConsentUpdatePayload,
  ChallengeReduxState,
} from '../types/models/challenges';

export const emptyChallenge: ChallengeReduxState = {
  _id: null,
  background_image: null,
  daysLeft: null,
  description: null,
  end_date: null,
  isActive: null,
  leaders: [],
  participantsNumber: null,
  start_date: null,
  target: null,
  teamProgressCompleted: null,
  teamProgressRemaining: null,
  title: null,
  type: null,
  userGaveConsent: false,
  userProgressOverall: null,
  userProgressToday: null,
  users: [],
  userPlace: null,
};

const challengesSlice = createSlice({
  name: 'challenge',
  initialState: {
    challenge: emptyChallenge,
  },
  reducers: {
    setChallenge: (state, action: PayloadAction<{ challenge: ChallengeReduxState }>) => {
      if (action.payload) {
        // eslint-disable-next-line no-param-reassign
        state.challenge = action.payload.challenge;
      }
    },
    setChallengeAfterToogleConsent: (
      state,
      action: PayloadAction<{ challenge: ChallengeConsentUpdatePayload }>
    ) => {
      if (action.payload) {
        // eslint-disable-next-line no-param-reassign
        state.challenge = {
          ...state.challenge,
          users: action.payload.challenge.users,
          leaders: action.payload.challenge.leaders,
          userGaveConsent: action.payload.challenge.userGaveConsent,
          userPlace: action.payload.challenge.userPlace,
        };
      }
    },
  },
});

export const { setChallenge, setChallengeAfterToogleConsent } = challengesSlice.actions;
export default challengesSlice.reducer;
